import common from "./fr.json";
import { frTranslations as login } from "../../pages/LocalLogin/translations";
import { frTranslations as paymentMethods } from "../../pages/PaymentMethods/translations";
import { frTranslations as dashboard } from "../../pages/Dashboard/translations";
import { frTranslations as invoices } from "../../pages/Invoices/translations";
import { frTranslations as payInvoices } from "../../pages/PayInvoices/translations";
import { frTranslations as invoice } from "../../pages/Invoice/translations";
import { frTranslations as securityDeposit } from "../../pages/SecurityDeposit/translations";

export default {
  common,
  login,
  dashboard,
  paymentMethods,
  invoices,
  payInvoices,
  invoice,
  securityDeposit,
};
